export default __webpack_public_path__ + "static/media/question.66ed48b3.png";